import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ClientAuthContext = createContext(null);

export const useClientAuth = () => {
  const context = useContext(ClientAuthContext);
  if (!context) {
    throw new Error('useClientAuth must be used within a ClientAuthProvider');
  }
  return context;
};

// Separate axios instance for client portal — does NOT share tokens with employee API
const clientApi = axios.create({
  baseURL: '',
});

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('client_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const clientApiRequest = clientApi;

export const ClientAuthProvider = ({ children }) => {
  const [clientUser, setClientUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadClient = async () => {
      const token = localStorage.getItem('client_token');
      if (token) {
        try {
          const response = await clientApi.get('/api/client/me');
          setClientUser(response.data);
        } catch (error) {
          console.error('Failed to load client session:', error);
          localStorage.removeItem('client_token');
          localStorage.removeItem('client_user');
        }
      }
      setLoading(false);
    };

    loadClient();
  }, []);

  const clientLogin = async (ar_code, password) => {
    const response = await clientApi.post('/api/client/login', { ar_code, password });
    const { token, client } = response.data;
    localStorage.setItem('client_token', token);
    localStorage.setItem('client_user', JSON.stringify(client));
    setClientUser(client);
    return client;
  };

  const employeeLogin = async (email, password) => {
    const response = await clientApi.post('/api/client/employee-login', { email, password });
    const { token, client } = response.data;
    localStorage.setItem('client_token', token);
    localStorage.setItem('client_user', JSON.stringify(client));
    setClientUser(client);
    return client;
  };

  const clientLogout = () => {
    localStorage.removeItem('client_token');
    localStorage.removeItem('client_user');
    setClientUser(null);
  };

  return (
    <ClientAuthContext.Provider value={{ clientUser, clientLogin, employeeLogin, clientLogout, loading }}>
      {children}
    </ClientAuthContext.Provider>
  );
};
